import { render, staticRenderFns } from "./PreviewRelease.vue?vue&type=template&id=3fbe32a8&scoped=true"
import script from "./PreviewRelease.vue?vue&type=script&lang=js"
export * from "./PreviewRelease.vue?vue&type=script&lang=js"
import style0 from "./PreviewRelease.vue?vue&type=style&index=0&id=3fbe32a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe32a8",
  null
  
)

export default component.exports